import axiosServer from '@/services/ApiInServer'
import { getDataConfig } from '../services/environment'
const stylePrint = (value) => {
  return JSON.stringify({
    type: 'style',
    value
  })
}

const alignPrint = (value) => {
  return JSON.stringify({
    type: 'align',
    value
  })
}

const fontPrint = (value) => {
  return JSON.stringify({
    type: 'font',
    value
  })
}

const sizePrint = (value1, value2) => {
  return JSON.stringify({
    type: 'size',
    value: [value1, value2]
  })
}

const textPrint = (value) => {
  return JSON.stringify({
    type: 'text',
    value
  })
}
const feedPrint = (value) => {
  return JSON.stringify({
    type: 'feed',
    value
  })
}

const qrPrint = (qr, margin, size) => {
  return JSON.stringify({
    type: 'qr',
    value: {
      code: qr,
      obj: {
        type: 'png',
        margin,
        size
      }
    }
  })
}

const cutPrint = (value, value2) => {
  return JSON.stringify({
    type: 'cut',
    value: [value, value2]
  })
}

const close = () => {
  return JSON.stringify({
    type: 'close'
  })
}

const setFooterPrinter = () => {
  const envFooter = getDataConfig().VUE_APP_FOOTER_PRINT_TICKET
  const footer = envFooter.reduce((prev, item) => {
    if (item.type === 'text') prev.push(`${textPrint(item.value)}`)
    else if (item.type === 'enter') prev.push(`${feedPrint('1')}`)
    return prev
  }, [])
  return footer
}

const printServer = ({ header, checkInTime, antrian, cluster, dokter, qrCode, time, reprinted }) => {
  const dokterPrint = []
  if (dokter && dokter.length > 0) {
    dokterPrint.push(`${sizePrint(0, 0.4)}`)
    for (let i = 0; i < dokter.length; i++) {
      dokterPrint.push(`${textPrint(dokter[i].name)}`)
      dokterPrint.push(`${textPrint(dokter[i].poli)}`)
      dokterPrint.push(`${textPrint(dokter[i].timeWithDate)}`)
      dokterPrint.push(`${textPrint('----')}`)
    }
  }
  const footerPrinter = setFooterPrinter()
  const arrPrint = [
    `${alignPrint('ct')}`,
    `${fontPrint('a')}`,
    ...(header ? [`${sizePrint(1, 1.2)}`, `${textPrint(header)}`] : []),
    ...(checkInTime ? [`${sizePrint(0, 0.4)}`, `${textPrint(checkInTime)}`, `${feedPrint('1')}`] : []),
    `${sizePrint(0, 0.4)}`,
    `${textPrint('Selamat datang')}`,
    `${textPrint('Nomor Tiket Anda:')}`,
    `${feedPrint('2')}`,
    ...(antrian ? [`${sizePrint(4, 4)}`, `${textPrint(antrian)}`, `${feedPrint('2')}`] : []),
    ...(dokterPrint.length > 0 ? dokterPrint : []),
    `${sizePrint(0, 0.4)}`,
    `${textPrint('QR Code:')}`,
    ...(qrCode ? [`${qrPrint(qrCode, 6, 6)}`] : []),
    ...footerPrinter,
    `${feedPrint('1')}`,
    ...(cluster ? [`${stylePrint('normal')}`, `${textPrint(cluster)}`, `${feedPrint('1')}`] : []),
    ...(reprinted ? [`${textPrint('Re-Printed at')}`] : []),
    `${textPrint('---' + time + '----')}`,
    `${feedPrint('3')}`,
    `${cutPrint(1, 7)}`,
    `${close()}`
  ]
  const arrPrintParse = arrPrint.map(_item => JSON.parse(_item))
  return arrPrintParse
}

export default {
  checkLocalStorage (type) {
    return new Promise((resolve) => {
      if (localStorage.getItem(type)) {
        resolve(true)
      } else {
        resolve(false)
      }
    })
  },
  restartKiosk () {
    axiosServer.get('restart')
  },
  shutdownKiosk () {
    axiosServer.get('turn-off')
  },
  async printKiosk (data) {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const body = {
      data: await printServer(data)
    }
    return axiosServer.post('print-usb', body, headers)
  },
  async printKioskWithServer (dataServer, data) {
    const envData = getDataConfig()
    const url = envData.VUE_APP_URL_PRINTER
    const secret = envData.VUE_APP_SECRET_PRINTER
    var md5 = require('md5')
    const md5Concat = (address, port, secret, timeUtc) => {
      const strAll = `${address}-${port}-${timeUtc}-${secret}`
      return md5(strAll)
    }
    const headers = new Headers()
    const port = dataServer.port
    const address = dataServer.host
    const timeUtc = new Date().toISOString()
    const key = md5Concat(address, port, secret, timeUtc)
    headers.append('Content-Type', 'application/json')
    headers.append('Access-Control-Allow-Origin', '*')
    const body = {
      address,
      port,
      timeStamp: timeUtc,
      key,
      data: await printServer(data)
    }
    return new Promise((resolve) => {
      fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
      }).then(() => {
        resolve(true)
      }).catch(_err => _err)
    })
  },
  getStatusPrinter () {
    return axiosServer.get('status-usb')
  },
  errorSlack (context, isNetwork = false) {
    const envData = getDataConfig()
    const nama = context.config.cluster.nama
    const floor = context.config.cluster.floor
    const localDevice = JSON.parse(localStorage['config-kiosk'])
    const title = isNetwork ? `Gagal Print Network ${context.config.printer.host}:${context.config.printer.port}` : 'Gagal print'
    const body = {
      pretext: `Kiosk Antrian ${nama} | ${floor}`,
      color: '#f90000',
      fields: [
        {
          title: `${title} - ${window.location.origin}`,
          value: `Tiket tidak keluar pada device ${localDevice.deviceId}`,
          short: false
        }
      ]
    }
    return fetch(envData.VUE_APP_REPORT_ERROR, {
      method: 'POST',
      body: JSON.stringify(body)
    })
  },
  errorSlackKioskCheckIn (context, { isSocket, isCheckIn }) {
    const envData = getDataConfig()
    const nama = context.config.cluster && context.config.cluster.nama ? context.config.cluster.nama : ''
    const info = context.config.cluster && context.config.cluster.info ? context.config.cluster.info : ''
    const title = isCheckIn ? 'Gagal Check In' : 'Gagal Get Info Ticket'
    const inSocket = isSocket ? ' (Socket Error)' : ''
    const bodyValue = isCheckIn ? 'Tiket tidak bisa checkin pada device' : 'Tiket tidak bisa get info pada device'
    const localDevice = JSON.parse(localStorage['config-kiosk'])
    const body = {
      pretext: `Kiosk check-in ${info} | ${nama}`,
      color: '#e2f816',
      fields: [
        {
          title: `${inSocket}${title} - ${window.location.origin}`,
          value: `${bodyValue} ${localDevice.deviceId} - ${context.generatedId}`,
          short: false
        }
      ]
    }
    return fetch(envData.VUE_APP_REPORT_ERROR, {
      method: 'POST',
      body: JSON.stringify(body)
    })
  },
  errorSlackReprintKioskAntrian (context, { isReprint, isGetInfo, isSocket }) {
    const envData = getDataConfig()
    const nama = context.config.cluster.nama
    const floor = context.config.cluster.floor
    const localDevice = JSON.parse(localStorage['config-kiosk'])
    const getInfoText = isGetInfo ? 'Gagal get info untuk Reprint' : ''
    const reprintText = isReprint ? 'Gagal Reprint' : ''
    const socketText = isSocket ? ' (Socket Error)' : ''
    const body = {
      pretext: `Kiosk Antrian ${nama} | ${floor}`,
      color: '#0004ff',
      fields: [
        {
          title: `${getInfoText}${reprintText} ${window.location.origin}`,
          value: `${socketText} ${localDevice.deviceId}`,
          short: false
        }
      ]
    }
    return fetch(envData.VUE_APP_REPORT_ERROR, {
      method: 'POST',
      body: JSON.stringify(body)
    })
  }
}
